<template>
  <div class="user-management krwManagement-container">
    <div class="user-management-header main-second-bg">
      <img :src="headImg" class="user-management-header-img" />
      <div class="user-management-header-message b-1-cl">
        <p>
          <span>{{ nickName }}</span>
          <c-button @click="modify(1)" type="text">
            {{ this.$t("personal.tool.modify") }}
          </c-button>
        </p>
        <p class="b-1-cl">{{ userName }}</p>
        <p class="b-2-cl">{{ this.$t("personal.userManagement.id") }}: {{ id }}</p>
      </div>
      <img :src="photo" class="user-management-header-img2" />
    </div>
    <div class="user-management-content a-7-bd main-second-bg">
      <!-- 认证 -->
      <p class="title medium b-1-cl a-3-bd">{{ $t("personal.krw.auth") }}</p>
      <div class="user-management-main clearfix">
        <ul class="ul">
          <!-- 身份认证 -- krw定制 -->
          <li class="li clearfix">
            <!--icon占位用-->
            <svg class="li-icon icon icon-24" aria-hidden="true">
              <use xlink:href="#icon-e_2"></use>
            </svg>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <!-- 手机号实名认证（韩国人认证入口） -->
              <p class="li-title">{{ $t("personal.krw.niceN") }}</p>
              <!-- 为了您的资产安全，请尽快完成认证 -->
              <p class="b-2-cl">{{ $t("personal.krw.niceText") }}</p>
              <div class="li-right clearfix">
                <span v-if="krwPhoneAuth === '1'" class="li-fun b-2-cl clearfix li-fun-no">
                  {{ this.$t("personal.state.certified") }}</span
                >
                <c-button
                  v-if="krwPhoneAuth === '0'"
                  type="solid"
                  :big="true"
                  className="user-button"
                  paddingW="18px"
                  height="30px"
                  @click="krwAuthentication"
                >
                  {{ this.$t("personal.state.certification") }}</c-button
                >
              </div>
            </div>
          </li>
          <!-- 谷歌验证码 -->
          <li class="li clearfix" style="border-bottom-width: inherit">
            <!--icon占位用-->
            <svg class="li-icon icon icon-24" aria-hidden="true">
              <use xlink:href="#icon-e_5"></use>
            </svg>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <p class="li-title">OTP</p>
              <p class="li-text b-1-cl">
                {{ this.$t("personal.userManagement.securityList.phone.label") }}
              </p>
              <div class="li-right clearfix">
                <c-button v-if="smsCode && googleCode" type="text" className="li-fun">
                  <router-link class="b-4-cl" to="/personal/closeGoogle">
                    {{ this.$t("personal.state.closeValidatio") }}</router-link
                  >
                </c-button>
                <!--
                <span v-if="smsCode&&googleCode" class="li-fun b-4-cl clearfix">
                  <router-link class="b-4-cl" to="/personal/closeGoogle">
                    {{this.$t('personal').state.closeValidatio}}</router-link></span>
                    -->
                <c-button
                  v-if="!googleCode"
                  type="solid"
                  :big="true"
                  className="user-button"
                  paddingW="18px"
                  height="30px"
                  @click="btnLink('google')"
                  >{{ this.$t("personal.tool.bind") }}</c-button
                >
                <span v-if="googleCode && !smsCode" class="li-fun b-1-cl clearfix">
                  {{ this.$t("personal.state.open") }}</span
                >
              </div>
            </div>
          </li>
          <!-- 银行账号 -->
          <li class="li clearfix">
            <!--icon占位用-->
            <svg class="li-icon icon icon-24" aria-hidden="true">
              <use xlink:href="#icon-e_4"></use>
            </svg>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <p class="li-title">
                <!-- 银行卡 -->
                {{ $t("personal.krw.bank") }}
              </p>
              <p class="li-text b-2-cl">
                <!-- 绑定后才可提现 -->
                {{ $t("personal.krw.bankText") }}
              </p>
              <div class="li-right clearfix">
                <c-button
                  v-if="!krwUserBank"
                  type="solid"
                  :big="true"
                  className="user-button"
                  paddingW="18px"
                  height="30px"
                  @click="krwBindBank"
                  >{{ this.$t("personal.tool.bind") }}</c-button
                >
                <c-button type="text" v-if="krwUserBank" className="li-fun" @click="krwBindBank">
                  {{ this.$t("personal.tool.modify") }}
                </c-button>
                <p class="li-email b-2-cl clearfix" v-if="krwUserBank">{{ krwUserBank.cardNo }}</p>
              </div>
            </div>
          </li>
          <!-- 实名认证 -->
          <li class="li clearfix">
            <!--icon占位用-->
            <svg class="li-icon icon icon-24" aria-hidden="true">
              <use xlink:href="#icon-e_2"></use>
            </svg>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <p class="li-title">
                <!-- 身份认证 -->
                {{ $t("personal.krw.authLevel") }}
              </p>
              <!-- 为了您的资产安全，请尽快完成身份认证 -->
              <p class="b-2-cl" v-if="authLevel !== 1">
                {{ $t("personal.krw.authLevelText") }}
              </p>
              <div class="li-right clearfix">
                <!-- <c-button
                  v-if="authLevel === 0"
                  type="text"
                  className="li-fun">
                  {{this.$t('personal').state.authentication}}
                </c-button> -->
                <span v-if="authLevel === 0" class="li-fun b-2-cl clearfix li-fun-no">
                  {{ this.$t("personal.state.authentication") }}</span
                >
                <!--
                <span v-if="authLevel === 0" class="li-fun b-4-cl clearfix"
                      @click="btnLink('identity')">{{this.$t('personal').state.authentication}}
                </span>
                -->
                <span v-if="authLevel === 1" class="li-fun b-2-cl clearfix li-fun-no">
                  {{ this.$t("personal.state.certified") }}</span
                >
                <c-button
                  v-if="authLevel === 2 || authLevel === 3"
                  type="solid"
                  :big="true"
                  className="user-button"
                  paddingW="18px"
                  height="30px"
                  @click="krwUserAuthClick"
                >
                  {{ this.$t("personal.state.certification") }}</c-button
                >
              </div>
            </div>
          </li>
        </ul>
        <!-- 账号 -->
        <p class="title medium b-1-cl a-3-bd clearfix title2">
          {{ $t("personal.krw.account") }}
        </p>
        <ul class="ul">
          <!-- 登录密码 -->
          <li class="li clearfix">
            <!--icon占位用-->
            <svg class="li-icon icon icon-24" aria-hidden="true">
              <use xlink:href="#icon-e_1"></use>
            </svg>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <p class="li-title">
                {{ this.$t("personal.userManagement.securityList.password.text") }}
              </p>
              <p class="li-text b-2-cl">
                {{ this.$t("personal.userManagement.securityList.password.label") }}
              </p>
              <div class="li-right clearfix">
                <c-button @click="changePassword" className="li-fun" type="text">
                  {{ this.$t("personal.tool.modify") }}
                </c-button>
                <!--
                <span class="li-fun b-4-cl clearfix" @click="changePassword">
                </span>
                -->
              </div>
            </div>
          </li>
          <!-- 邮箱 -->
          <li class="li clearfix">
            <!--icon占位用-->
            <svg class="li-icon icon icon-24" aria-hidden="true">
              <use xlink:href="#icon-e_3"></use>
            </svg>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <p class="li-title">
                {{ this.$t("personal.userManagement.securityList.email.text") }}
              </p>
              <p class="li-text b-2-cl">
                {{ this.$t("personal.userManagement.securityList.email.label") }}
              </p>
              <div class="li-right clearfix">
                <c-button v-if="email" type="text" className="li-fun" @click="changeEmail">
                  {{ this.$t("personal.tool.modify") }}
                </c-button>
                <!--
                <span v-if="email"
                      class="li-fun b-4-cl clearfix"
                      @click="changeEmail">{{this.$t('personal').tool.modify}}</span>
                      -->
                <c-button
                  v-else
                  type="solid"
                  :big="true"
                  className="user-button"
                  paddingW="18px"
                  height="30px"
                  @click="btnLink('email')"
                  >{{ this.$t("personal.tool.bind") }}</c-button
                >
                <p v-if="email" class="li-email b-2-cl clearfix">{{ email }}</p>
              </div>
            </div>
          </li>
          <!-- 手机号 -->
          <li class="li clearfix">
            <!--icon占位用-->
            <svg class="li-icon icon icon-24" aria-hidden="true">
              <use xlink:href="#icon-e_4"></use>
            </svg>
            <div class="li-div a-3-bd b-1-cl clearfix">
              <p class="li-title">
                {{ this.$t("personal.userManagement.securityList.phone.text") }}
              </p>
              <p class="li-text b-2-cl">
                {{ this.$t("personal.userManagement.securityList.phone.label") }}
              </p>
              <div class="li-right clearfix">
                <c-button v-if="smsCode && googleCode" type="text" className="li-fun li-fun1">
                  <router-link class="b-4-cl" to="/personal/closePhone">
                    {{ this.$t("personal.state.closeValidatio") }}</router-link
                  >
                </c-button>
                <!--
                <span v-if="smsCode&&googleCode" class="li-fun li-fun1 b-4-cl clearfix">
                  <router-link class="b-4-cl" to="/personal/closePhone">
                    {{this.$t('personal').state.closeValidatio}}</router-link></span>
                    -->
                <c-button
                  v-if="!smsCode && mobileNumber"
                  className="li-fun"
                  type="text"
                  style="margin-left: 22px"
                  @click="openMobile"
                >
                  {{ this.$t("personal.state.openValidatio") }}
                </c-button>
                <!--
                <span v-if="!smsCode&&mobileNumber" class="li-fun b-4-cl clearfix"
                      style="margin-left: 22px;"
                      @click="openMobile">{{this.$t('personal').state.openValidatio}}</span>
                      -->
                <c-button v-if="mobileNumber" type="text" className="li-fun">
                  <router-link class="b-4-cl" to="/personal/changePhone">
                    {{ this.$t("personal.tool.modify") }}</router-link
                  >
                </c-button>
                <!--
                <span v-if="mobileNumber" class="li-fun b-4-cl clearfix">
                  <router-link class="b-4-cl" to="/personal/changePhone">
                    {{this.$t('personal').tool.modify}}</router-link></span>
                    -->
                <c-button
                  v-if="!mobileNumber"
                  type="solid"
                  :big="true"
                  className="user-button"
                  paddingW="18px"
                  height="30px"
                  @click="btnLink('phone')"
                  >{{ this.$t("personal.tool.bind") }}</c-button
                >
                <p class="li-email b-2-cl clearfix" v-if="mobileNumber">{{ mobileNumber }}</p>
              </div>
            </div>
          </li>
        </ul>
        <p class="title medium b-1-cl a-3-bd clearfix title2" v-show="feeCoinOpen === '1'">
          {{ this.$t("personal.userManagement.otherTitle") }}
        </p>
        <ul class="ul">
          <li class="li">
            <!--icon占位用-->
            <svg class="li-icon icon icon-24" aria-hidden="true">
              <use xlink:href="#icon-e_6"></use>
            </svg>
            <div class="li-div a-3-bd b-1-cl">
              <p class="li-title">
                {{ this.$t("personal.userManagement.otherList.poundage.text") }}
              </p>
              <p class="li-text b-1-cl">
                {{ this.$t("personal.userManagement.otherList.poundage.label") }}
              </p>
              <div class="li-right">
                <c-switch :value="switchValue" @click="switchChange" />
              </div>
            </div>
          </li>
          <li class="li">
            <!--icon占位用-->
            <svg class="li-icon icon icon-24" aria-hidden="true">
              <use xlink:href="#icon-b_11"></use>
            </svg>
            <div class="li-div a-3-bd b-1-cl">
              <p class="li-title">
                {{ this.$t("personal.userManagement.otherList.myInviteCod.text") }}
              </p>
              <p class="li-text b-1-cl">
                {{ this.$t("personal.userManagement.otherList.myInviteCod.label") }}
              </p>
              <div class="li-right">
                <c-button @click="modify(2)" type="text">
                  {{ this.$t("personal.tool.view") }}
                </c-button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <c-dialog
      :showFlag="dialogFlag"
      paddingBottom="14px"
      :confirmLoading="dialogConfirmLoading"
      :confirmDisabled="dialogConfirmDisabled"
      @close="dialogClose"
      @confirm="dialogConfirm"
      :titleText="this.$t('personal.dialog.title')"
    >
      <!-- 验证框 -->
      <c-inputLine
        v-if="dialogType === 1"
        name="checkValue"
        maxLength="10"
        :promptText="promptText"
        :errorHave="true"
        :errorText="errorText"
        :errorFlag="checkErrorFlag"
        marginTop="0px"
        :value="checkValue"
        @onchanges="inputChanges"
        @focus="checkFocus"
      >
      </c-inputLine>
      <div class="dialog-div a-4-bg" v-if="dialogType === 2">
        <div class="dialog-div-module a-5-bd">
          <p>{{ $t("personal.label.inviteCode") }}</p>
          <p>
            <span class="b-1-cl">{{ inviteCode }}</span>
            <span
              @click="copyClick('inviteCode')"
              @mouseenter="handMouseenter('inviteCode')"
              @mouseleave="handMouseleave('inviteCode')"
            >
              <span v-if="inviteCodeShow">
                <svg class="icon icon-14" aria-hidden="true">
                  <use xlink:href="#icon-a_9"></use>
                </svg>
              </span>
              <span v-else>
                <svg class="icon icon-14" aria-hidden="true">
                  <use xlink:href="#icon-a_9_1"></use>
                </svg>
              </span>
            </span>
          </p>
        </div>
        <div class="dialog-div-module a-5-bd">
          <p>{{ $t("personal.label.inviteUrl") }}</p>
          <p>
            <span class="b-1-cl">{{ inviteUrl }}</span>
            <span
              @click="copyClick('inviteUrlShow')"
              @mouseenter="handMouseenter('inviteUrlShow')"
              @mouseleave="handMouseleave('inviteUrlShow')"
            >
              <span v-if="inviteUrlShow">
                <svg class="icon icon-14" aria-hidden="true">
                  <use xlink:href="#icon-a_9"></use>
                </svg>
              </span>
              <span v-else>
                <svg class="icon icon-14" aria-hidden="true">
                  <use xlink:href="#icon-a_9_1"></use>
                </svg>
              </span>
            </span>
          </p>
        </div>
        <div class="dialog-div-module a-5-bd">
          <p>{{ $t("personal.label.inviteQECode") }}</p>
          <div class="img-div main-second-bg">
            <img :src="inviteQECode" />
          </div>
        </div>
      </div>
    </c-dialog>
    <!-- 身份认证对话框 -- krw定制 -->
    <c-dialog
      :showFlag="krwAuthFlag"
      paddingBottom="14px"
      @close="krwAuthClose"
      @confirm="krwAuthConfirm"
      :titleText="$t('personal.krw.authLevel')"
    >
      <!-- 请选择您的国籍 -->
      <c-select
        :value="krwAuthType"
        :promptText="$t('personal.krw.selectArea')"
        name="krwAuth"
        :errorHave="true"
        :options="krwAuthTypeOptions"
        @onChanges="krwAuthTypeChange"
      />
    </c-dialog>
    <!-- nice认证 确认 -- krw定制 -->
    <c-dialog
      :showFlag="krwConfrimFlag"
      paddingBottom="14px"
      @close="krwConfirmClick"
      @confirm="krwConfirmClick"
      :confirmText="$t('personal.krw.niceConfrim')"
      :titleText="$t('personal.krw.niceConfrimTitle')"
    >
      <p class="niceConfirmText">{{ $t("personal.krw.niceConfrimText") }}</p>
    </c-dialog>
    <!-- 提示框 -->
    <c-alert
      :showFlag="alertFlag"
      :buttonText="this.$t('personal').alert.button"
      imageType="1"
      :imgMap="imgMap"
      @close="alertClose"
      @confirm="alertGo"
      :title="$t('personal.alert.title')"
    >
      <!-- <div class="alertTitle b-1-cl">{{ this.$t("personal.alert.title") }}</div> -->
      <div class="alertText">{{ this.$t("personal.alert.text") }}</div>
      <div class="alertErrorr gray-10-bd">
        <svg-icon iconClass="icon-right-answer" className="icon-16"></svg-icon>
        <span class="alertError-text main-cl">
          {{ this.$t("personal.alert.alertErrorTextGoogle") }}</span
        >
        <!-- <svg class="icon icon-14 alertError-icon" aria-hidden="true">
          <use xlink:href="#icon-a_14"></use>
        </svg> -->
      </div>
      <div class="alertErrorr alertBot gray-10-bd">
        <svg-icon iconClass="icon-right-answer" className="icon-16"></svg-icon>
        <span class="alertError-text main-cl">
          {{ this.$t("personal.alert.alertErrorTextPhone") }}</span
        >
        <!-- <svg class="icon icon-14 alertError-icon" aria-hidden="true">
          <use xlink:href="#icon-a_14"></use>
        </svg> -->
      </div>
    </c-alert>
    <!-- 提示框 -->
    <c-verifyCationc-alert
      :showFlag="krwAlertFlag"
      :imgMap="imgMap"
      :titleText="$t('assets.addressMent.safetyWarning')"
      :detaText="$t('personal.krw.alertText')"
      :dataList="krwAlertData"
      :buttonText="$t('personal.krw.inow')"
      @close="krwAlertClose"
      @confirm="krwAlertClose"
    />
  </div>
</template>

<script>
import { imgMap, colorMap } from '@/utils';

export default {
  name: 'krwManagement',
  data() {
    return {
      id: '', // uid
      mobileNumber: '', // 手机号或者邮箱显示
      authLevel: '', // 身份/实名认证状态，0、未审核，1、通过，2、未通过  3未认证
      nickName: '', // 昵称
      userName: '',
      imgMap,
      colorMap,
      email: '', // 邮箱
      dialogType: 1,
      is_krw_phone_auth: '', // NICE认证 1：已完成手机认证   0：未完成手机认证
      dialogFlag: false,
      dialogConfirmLoading: false,
      dialogConfirmDisabled: false,
      checkErrorFlag: false,
      checkValue: '',
      promptText: this.$t('personal.dialog.name'),
      errorText: this.$t('personal.dialog.text'),
      oldName: '', // 用户最初昵称
      smsCode: false, // false对应0 关闭 true对应1 开启(手机短信认证)
      googleCode: false, // false对应0 关闭 true对应1 开启(google认证)
      switchValue: false, // 手续费设置
      clickType: true, // 可点击状态
      alertFlag: false,
      feeCoinOpen: '0',
      photo: imgMap.photo1,
      krwAuthFlag: false, // 身份认证对话框开关 -- krw定制
      krwAuthType: '1', // 身份认证对话框 select 选择值 -- krw定制
      krwAlertFlag: false, // krw 绑定银行卡前置条件校验
      krwConfrimFlag: false, // krw nice认证确认是否通过验证
      // 邀请码信息
      inviteCodeShow: true,
      inviteUrlShow: true,
      inviteCode: '',
      inviteQECode: '',
      inviteUrl: '',
      titleText: this.$t('personal.dialog.title'),
    };
  },
  watch: {
    userInfo(userinfo) {
      // 监听userinfo接口
      if (userinfo) {
        this.getUserInfo(); // 获取用户信息
      }
      this.googleCode = !!Number(userinfo.googleStatus);
      this.smsCode = !!Number(userinfo.isOpenMobileCheck);
      this.id = userinfo.id;
    },
    modifyNickName(modifyNickName) {
      // 修改昵称逻辑操作
      if (modifyNickName !== null) {
        if (modifyNickName.text === 'success') {
          // tip框提示
          this.$bus.$emit('tip', { text: modifyNickName.msg, type: 'success' });
          // 重新获取 userinfo
          this.$store.dispatch('getUserInfo');
          this.dialogConfirmFlag = false;
          this.dialogFlag = false;
          this.checkValue = this.oldName;
          this.checkErrorFlag = false;
          this.dialogConfirmLoading = false;
          this.$store.dispatch('resetType');
        } else {
          // tip框提示错误
          this.$bus.$emit('tip', { text: modifyNickName.msg, type: 'error' });
          this.$store.dispatch('resetType');
          this.dialogConfirmLoading = false;
        }
      }
    },
    openMobileVerify(openMobileVerify) {
      if (openMobileVerify !== null) {
        if (openMobileVerify.text === 'success') {
          this.$bus.$emit('tip', { text: openMobileVerify.msg, type: 'success' });
          this.$store.dispatch('resetType');
          this.$store.dispatch('getUserInfo');
        } else {
          this.$bus.$emit('tip', { text: openMobileVerify.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
    updateFeeCoinOpen(updateFeeCoinOpen) {
      if (updateFeeCoinOpen !== null) {
        const type = this.switchValue;
        if (updateFeeCoinOpen.text === 'success') {
          if (type) {
            this.$bus.$emit('tip', {
              text: this.$t('personal.state.closeSuccess'),
              type: 'success',
            });
            this.switchValue = !type;
            this.$store.dispatch('resetType');
          } else {
            this.$bus.$emit('tip', {
              text: this.$t('personal.state.openSuccess'),
              type: 'success',
            });
            this.switchValue = !type;
            this.$store.dispatch('resetType');
          }
        } else {
          this.$bus.$emit('tip', { text: updateFeeCoinOpen.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
  },
  computed: {
    // 身份认证对话框 select 列表 -- krw定制
    krwAuthTypeOptions() {
      return [
        // 韩国
        { value: this.$t('personal.krw.authType'), code: '1' },
        // 外国人
        { value: this.$t('personal.krw.authOther'), code: '2' },
      ];
    },
    krwAlertData() {
      let authFlag = false;
      if (this.krwPhoneAuth === '1' || this.authLevel === 1) {
        authFlag = true;
      }
      const arr = [
        // 请您先完成NICE认证或身份认证
        { text: this.$t('personal.krw.alertk'), flag: authFlag },
        // OTP认证
        { text: this.$t('personal.krw.OTPk'), flag: Boolean(this.googleCode) },
      ];
      return arr;
    },
    krwUserBank() {
      return this.$store.state.personal.krwUserBank;
    },
    // 该用户是否完成nice认证
    krwPhoneAuth() {
      let str = '0';
      if (this.userInfo && this.userInfo.is_krw_phone_auth) {
        str = this.userInfo.is_krw_phone_auth.toString();
      }
      return str;
    },
    // 开启验证方式
    coinsKrwOpen() {
      const { publicInfo } = this.$store.state.baseData;
      let str = '0';
      if (publicInfo && publicInfo.switch && publicInfo.switch.coins_krw_open) {
        str = publicInfo.switch.coins_krw_open.toString();
      }
      return str;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    modifyNickName() {
      return this.$store.state.personal.modifyNickName;
    },
    openMobileVerify() {
      return this.$store.state.personal.openMobileVerify;
    },
    updateFeeCoinOpen() {
      return this.$store.state.personal.updateFeeCoinOpen;
    },
    headImg() {
      return imgMap.head;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch('getUserInfo');
    },
    krwConfirmClick() {
      this.krwConfrimFlag = false;
      this.$store.dispatch('getUserInfo');
    },
    krwAlertClose() {
      this.krwAlertFlag = false;
    },
    // krw 绑定银行卡
    krwBindBank() {
      let authFlag = false;
      if (this.krwPhoneAuth === '1' || this.authLevel === 1) {
        authFlag = true;
      }
      if (this.googleCode && authFlag) {
        this.$router.push('/personal/krwBank');
      } else {
        this.krwAlertFlag = true;
      }
    },
    // nice证对话框 clone -- krw定制
    krwAuthClose() {
      this.krwAuthFlag = false;
    },
    // nice对话框 confirm -- krw定制
    krwAuthConfirm() {
      if (this.krwAuthType === '1') {
        // window.open('/ex/personal/krwKyc');
        if (this.krwPhoneAuth === '1') {
          this.$router.push('/personal/idAuth');
        } else {
          this.krwAuthFlag = false;
          // 请您先完善手机实名认证
          this.$bus.$emit('tip', { text: this.$t('personal.krw.phonek'), type: 'warning' });
        }
      } else {
        this.$router.push('/personal/idAuth');
      }
    },
    // nice认证 点击认证按钮 -- krw定制
    krwAuthentication() {
      this.krwConfrimFlag = true;
      window.open(
        '/personal/krwKyc',
        '_blank',
        'menubar=0,scrollbars=1, resizable=1,status=1,titlebar=0,toolbar=0,location=1,height=614,width=432',
      );
      // window.open('/ex/personal/krwKyc');
      // this.$router.push('/personal/krwKyc');
    },
    // nice认证 选择国籍 -- krw定制
    krwAuthTypeChange(item) {
      this.krwAuthType = item.code;
    },
    // 身份认证点击
    krwUserAuthClick() {
      if (this.krwPhoneAuth === '1') {
        this.$router.push('/personal/idAuth');
      } else {
        this.krwAuthFlag = true;
      }
    },
    copyClick(name) {
      if (name === 'inviteCode') {
        this.copy(this.inviteCode);
      } else {
        this.copy(this.inviteUrl);
      }
    },
    copy(str) {
      // this.$bus.$emit('tip', { text: this.$t('personal.prompt.copySucces'), type: 'success' });
      function save(e) {
        e.clipboardData.setData('text/plain', str); // 下面会说到clipboardData对象
        e.preventDefault(); // 阻止默认行为
      }
      document.addEventListener('copy', save);
      document.execCommand('copy'); // 使文档处于可编辑状态，否则无效
      document.removeEventListener('copy', save);
    },
    handMouseenter(name) {
      if (name === 'inviteCode') {
        this.inviteCodeShow = false;
      } else {
        this.inviteUrlShow = false;
      }
    },
    handMouseleave(name) {
      if (name === 'inviteCode') {
        this.inviteCodeShow = true;
      } else {
        this.inviteUrlShow = true;
      }
    },
    btnLink(link) {
      if (link === 'google') {
        this.$router.push('/personal/bindGoogle');
      } else if (link === 'phone') {
        this.$router.push('/personal/bindPhone');
      } else if (link === 'email') {
        this.$router.push('/personal/bindEmail');
      } else if (link === 'krwBank') {
        this.$router.push('/personal/krwBank');
      } else {
        this.$router.push('/personal/idAuth');
      }
    },
    dialogClose() {
      // 关闭或取消时
      this.dialogConfirmDisabled = false;
      this.dialogConfirmFlag = false;
      this.dialogFlag = false;
      this.checkValue = this.oldName;
      this.checkErrorFlag = false;
    },
    dialogConfirm() {
      // 点击确认时
      if (this.dialogType === 2) {
        this.dialogConfirmFlag = false;
        this.dialogFlag = false;
      } else {
        const val = this.checkValue;
        if (val.length === 0) {
          // 为空提示
          this.checkErrorFlag = true;
          // 昵称不能为空
          this.errorText = this.$t('personal.userManagement.nameError1');
        } else if (val.length > 10) {
          this.checkErrorFlag = true;
          // 昵称长度不可超过十位
          this.errorText = this.$t('personal.userManagement.nameError2');
        } else {
          // 非空提交
          this.dialogConfirmLoading = true;
          this.$store.dispatch('modifyNickName', { nickname: val });
        }
      }
    },
    inputChanges(val) {
      // 获取输入框内容
      this.checkValue = val;
    },
    checkFocus() {},
    modify(num) {
      if (num === 1) {
        this.dialogType = 1;
        this.titleText = this.$t('personal.dialog.title');
      } else {
        this.dialogType = 2;
        this.titleText = this.$t('personal.userManagement.otherList.myInviteCod.text');
      }
      this.dialogConfirmFlag = true;
      this.dialogFlag = true;
    },
    getUserInfo() {
      if (this.userInfo !== null) {
        // 邀请码信息
        this.inviteCode = this.userInfo.inviteCode;
        this.inviteQECode = this.userInfo.inviteQECode;
        this.inviteUrl = this.userInfo.inviteUrl;
        // 邀请码信息
        this.userName = this.userInfo.mobileNumber !== '' ? this.userInfo.mobileNumber : this.userInfo.email; // 有电话号码显示电话号码,无则显示邮箱
        this.mobileNumber = this.userInfo.mobileNumber; // 电话号码
        this.nickName = this.userInfo.nickName !== ''
          ? this.userInfo.nickName
          : this.$t('personal.userManagement.userName');
        this.email = this.userInfo.email; // 邮箱
        this.checkValue = this.userInfo.nickName;
        this.oldName = this.userInfo.nickName;
        this.authLevel = this.userInfo.authLevel; // 身份认证状态
        // this.authLevel = 2
        this.is_krw_phone_auth = this.userInfo.is_krw_phone_auth; // NICE认证
        if (Number(this.userInfo.useFeeCoinOpen) === 1) {
          // 是否开启手续费设置 1 开启 0 关闭
          this.switchValue = true;
        } else {
          this.switchValue = false;
        }
        this.feeCoinOpen = this.userInfo.fee_coin_open;
      }
    },
    openMobile() {
      this.$store.dispatch('openMobileVerify');
    },
    switchChange() {
      if (this.clickType) {
        this.clickType = false;
        setTimeout(() => {
          this.clickType = true;
        }, 1000);
        if (this.switchValue) {
          const info = { useFeeCoinOpen: '0' };
          this.$store.dispatch('updateFeeCoinOpen', info);
        } else {
          const info = { useFeeCoinOpen: '1' };
          this.$store.dispatch('updateFeeCoinOpen', info);
        }
      }
    },
    changePassword() {
      if (this.smsCode === true || this.googleCode === true) {
        this.$router.push('/personal/changePassword');
      } else {
        this.alertFlag = true;
      }
    },
    changeEmail() {
      if (this.smsCode === true || this.googleCode === true) {
        this.$router.push('/personal/changeEmail');
      } else {
        this.alertFlag = true;
      }
    },
    alertClose() {
      this.alertFlag = false;
    },
    alertGo() {
      this.alertFlag = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-management.krwManagement-container {
  width: 100%;
  .niceConfirmText {
    padding-bottom: 20px;
  }
  .user-management-header {
    width: 100%;
    float: left;
    position: relative;
  }
  .user-management-header-img {
    float: left;
    width: 75px;
    height: 75px;
    margin: 38px 0 37px 20px;
  }
  .user-management-header-img2 {
    float: right;
    height: 122px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .user-management-header-message {
    float: left;
    margin: 30px 0 0 30px;
    font-size: 12px;
    p {
      button {
        margin-left: 10px;
      }
    }
  }
  .user-management-header-message p:nth-of-type(1) span {
    line-height: 24px;
  }
  .user-management-header-message span:nth-of-type(2) {
    margin-left: 10px;
    cursor: pointer;
  }
  .user-management-header-message p:nth-of-type(2) {
    margin: 10px 0 15px 0;
    font-size: 22px;
    font-weight: normal;
  }
  .user-management-content {
    float: left;
    width: 100%;
    height: 900px;
    border-top-style: solid;
    border-top-width: 10px;
    .title {
      padding: 20px;
      font-size: 14px;
      letter-spacing: 0;
      text-align: left;
      line-height: 16px;
      border-bottom-style: solid;
      border-bottom-width: 1px;
    }
    .title2 {
      float: left;
      width: 940px;
      border-top-style: solid;
      /* border-top-width: 1px; */
    }
  }
  .user-management-main {
    width: 100%;
    float: left;
  }
  .user-management-main ul li {
    width: 100%;
    float: left;
  }
  .li-icon {
    float: left;
    margin: 25px 20px;
  }
  .li-div {
    float: left;
    width: 910px;
    height: 80px;
    box-sizing: border-box;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    font-size: 14px;
    position: relative;
  }
  .li-div:last-of-type(1) {
    border-bottom-style: none;
    border-bottom-width: 0px;
  }
  .li-div p:nth-of-type(1) {
    margin-top: 20px;
    line-height: 24px;
  }
  .li-div p:nth-of-type(1).switchBottom,
  .li-div p:nth-of-type(1).switchBottomChecked {
    margin-top: 0;
  }
  .li-div p:nth-of-type(1).none {
    margin-top: 32px;
  }
  .li-div p:nth-of-type(2) {
    margin-top: 5px;
    font-size: 12px;
  }
  .li-right {
    position: absolute;
    top: 32px;
    right: 21px;
    float: right;
    .common-button {
      top: -5px;
    }
  }
  .li-fun {
    float: right;
    font-size: 12px;
    cursor: pointer;
  }
  .li-fun-no {
    cursor: default;
  }
  .li-fun1 {
    margin-left: 20px;
  }
  .li-div p:nth-of-type(1).li-email {
    margin-top: 0;
    font-size: 12px;
    float: right;
    margin-right: 22px;
    line-height: 18px;
  }
  .user-button {
    font-size: 12px;
    margin-top: -10px;
    .switchWrap {
      top: -15px;
    }
  }
  .alertTitle {
    margin-bottom: 15px;
  }
  .alertText {
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    padding: 16px 24px 24px;
    box-sizing: border-box;
  }
  .alertError {
    height: 40px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    padding: 10px 24px;
    box-sizing: border-box;
    .alertError-text {
      font-size: 14px;
      line-height: 20px;
      margin-left: 8px;
    }
  }
  .alertBot {
    margin-bottom: 16px;
  }
  .dialog-div {
    .dialog-div-module {
      padding: 18px 20px 15px 20px;
      border-bottom-style: solid;
      border-width: 1px;
      p:nth-of-type(1) {
        font-size: 12px;
        margin-bottom: 5px;
      }
      p:nth-of-type(2) {
        font-size: 14px;
        span:nth-of-type(2) {
          float: right;
        }
      }
      .img-div {
        width: 180px;
        height: 180px;
        margin-left: 90px;
        border-radius: 2px;
        img {
          width: 160px;
          height: 160px;
          margin: 10px;
        }
      }
    }
  }
}
</style>
